import React, { useEffect } from 'react';
import AOS from 'aos';
import "./Announcements.css";
import data from '../../data/index.json';
import OptimizedImage from '../../components/OptimizedImage/OptimizedImage';

// import { BsFillBookmarkFill } from "react-icons/bs";
// import { GrAnnounce } from "react-icons/gr";
// import { FaRegFilePdf } from "react-icons/fa6";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import HeroSection from '../../components/Hero/HeroSection';
import WhatsAppIcon from '../../components/WhatsAppIcon/WhatsAppIcon';

function Announcements() {

  useEffect(() => {
    AOS.init({
      duration: 2000
    });
  }, []);

  return (
    <div className="announcement-page">
      <HeroSection>
        <h1 className='hero-text-home'><span className='block-text'>{data.siteContent.pageHeaders.announcements}</span></h1>
      </HeroSection>
      {/*<h2 className="noTenders">No tenders or announcements available at the moment. Keep in touch !</h2>*/}
      {/*
      <h2 className="Announcement-section-title" data-aos="fade-up">Tenders</h2>
      <div className="tender-container">
        <ul className="tender-list">
          <p className="tender-item" data-aos="fade-up">
            <span className="bookmark-icon">
              <BsFillBookmarkFill size={25} />
            </span>
            About the tender detail should include here. About the tender detail
            should include here.
          </p>

          <p className="tender-item" data-aos="fade-up">
            <span className="bookmark-icon">
              <BsFillBookmarkFill size={25} />
            </span>
            About the tender detail should include here. About the tender detail
            should include here.
          </p>

          <p className="tender-item" data-aos="fade-up">
            <span className="bookmark-icon">
              <BsFillBookmarkFill size={25} />
            </span>
            About the tender detail should include here. About the tender detail
            should include here.
          </p>
          <p className="tender-item" data-aos="fade-up">
            <span className="bookmark-icon">
              <BsFillBookmarkFill size={25} />
            </span>
            About the tender detail should include here. About the tender detail
            should include here.
          </p>

        </ul>
      </div>
    */}

      {/*

      <h2 className="Announcement-section-title" data-aos="fade-up">

        <div className="announce-icon">
          <GrAnnounce size={40} />
        </div>
        Announcements
      </h2>*/}

      <div className="announcement-container">
        {data.announcements?.filter(announcement => announcement.status === 'active').map((announcement) => (
          <div key={announcement.id} className="announcement-card" data-aos="fade-up">
            <OptimizedImage
              src={announcement.image}
              className="announcement-image"
              alt={`${announcement.type} announcement`}
            />
            <div className="announcement-content">
              <h3 className="announcement-title">{announcement.title}</h3>
              <p className="announcement-details">
                {announcement.content}
              </p>
              <p className="announcement-details" style={{ marginBottom: "12%" }}>
                For full details, <a href={announcement.document_url} target="_blank" rel="noopener noreferrer">{announcement.document_text}</a>
                {announcement.document_url_2 && announcement.document_text_2 ? (
                  <> and <a href={announcement.document_url_2} target="_blank" rel="noopener noreferrer">{announcement.document_text_2}</a></>
                ) : null}.
              </p>
              <p className="announcement-details">
                {announcement.contact_email ? (
                  <>Send your resume to <a href={`mailto:${announcement.contact_email}`}>{announcement.contact_email}</a></>
                ) : (
                  announcement.additional_info
                )}
              </p>
              <div className="announcement-date">{announcement.date}</div>
            </div>
          </div>
        ))}

        {/* 
        <div className="announcement-card" data-aos="fade-up">
          <img
            src="https://drive.google.com/uc?export=view&id=1hlab_XVThsqw5eeK-KEdTcbkZybopJnJ"
            className="announcement-image"
            alt="announcement-2"
          />
          <div className="announcement-content">
            <h3 className="announcement-title">Executive manager positions available</h3>
            <p className="announcement-details">
              Announcement details include here. Announcement details include
              here.
            </p>
            <div className="announcement-date">September 29, 2023</div>
          </div>
        </div>

        <div className="announcement-card" data-aos="fade-up">
          <img
            src="https://drive.google.com/uc?export=view&id=1hlab_XVThsqw5eeK-KEdTcbkZybopJnJ"
            className="announcement-image"
            alt="announcement-3"
          />
          <div className="announcement-content">
            <h3 className="announcement-title">We are hiring</h3>
            <p className="announcement-details">
              Announcement details include here. Announcement details include
              here.
            </p>
            <div className="announcement-date">September 29, 2023</div>
          </div>

        </div>
        */}
      </div>

      <WhatsAppIcon />

    </div>
  );
}

export default Announcements;
